import Image from 'next/image';
import { RichText } from 'prismic-reactjs';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import Dribble from './icons/dribble.svg';
import Behance from './icons/behance.svg';
import { SocialItem } from './SocialItem/SocialItem';
import {
  SectionImage,
  SectionImageMobile,
  SocialMediaWrapper,
  SocialsWrapper,
  SocialText,
  SocialTitle,
  Wrapper,
} from './whatWeHaveBuilt.styles';
import { imageSerializer } from '../../../../utils/imageSerializer';
import Carousel from '../../../core/Carousel';

export const WhatWeHaveBuilt = ({
  id,
  title,
  want_to_see_more,
  behance_text,
  behance,
  dribbble_text,
  dribbble,
  images,
  mobileImages,
  titleAs,
}: any) => {
  const width = useWindowSize().width;
  let image;

  if (images && width && width >= 1200) {
    image = images.desktop;
  } else if (images && width && width >= 991) {
    image = images.tablet;
  } else {
    image = images.mobile;
  }

  return (
    <Wrapper id={id}>
      <SocialTitle as={titleAs}>{RichText.asText(title)}</SocialTitle>

      {width && width >= 768 ? (
        <SectionImage>
          <Image {...imageSerializer(image, { layout: 'fixed' })} />
        </SectionImage>
      ) : (
        <SectionImageMobile>
          <Carousel images={mobileImages} />
        </SectionImageMobile>
      )}

      <SocialMediaWrapper>
        <SocialText>{RichText.asText(want_to_see_more)}</SocialText>
        <SocialsWrapper>
          <SocialItem
            text={'Dribbble'}
            icon={<Dribble />}
            link={'https://dribbble.com/qodeca'}
          />
          <SocialItem
            text={'Behance'}
            icon={<Behance />}
            link={'https://www.behance.net/_qodeca'}
          />
        </SocialsWrapper>
      </SocialMediaWrapper>
    </Wrapper>
  );
};
